{"overview":{"waiting":"Probleme warten auf dich"},"setupChecklist":{"autoReason":"Wird automatisch abgehakt, sobald alles erfüllt ist","required":"Pflicht"}}